import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 9v4a9 9 0 0 1 -18 0v-4h7v4a2 2 0 1 0 4 0v-4zm-3 -7a3 3 0 0 1 3 3v2h-7v-2a3 3 0 0 1 3 -3zm-11 0a3 3 0 0 1 3 3v2h-7v-2a3 3 0 0 1 3 -3z","key":"svg-0"}]]

/**
 * IconMagnetFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItbWFnbmV0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0yMSA5djRhOSA5IDAgMCAxIC0xOCAwdi00aDd2NGEyIDIgMCAxIDAgNCAwdi00em0tMyAtN2EzIDMgMCAwIDEgMyAzdjJoLTd2LTJhMyAzIDAgMCAxIDMgLTN6bS0xMSAwYTMgMyAwIDAgMSAzIDN2MmgtN3YtMmEzIDMgMCAwIDEgMyAtM3oiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/magnet-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMagnetFilled = createReactComponent('filled', 'magnet-filled', 'MagnetFilled', __iconNode);

export default IconMagnetFilled;